/*
 * @description:
 * @Author: liwg
 * @Date: 2022-06-12 10:45:07
 * @LastEditors: liwg
 * @LastEditTime: 2022-11-18 09:44:56
 */

import type { LinkNums, QueryActivityParams, ReportConfigItem, ReviewActiItem } from './type'

enum Api {
  QueryActivity = '/ns-service-app-evaluation/accountActivity/queryActivityPaper',
  GetLinkNum = '/ns-service-app-evaluation/accountActivityLink/queryValidLinkNumByAccId',
  QueryReMarkingPaper = '/ns-service-app-evaluation/markingTeacherInfo/queryMarkingPaper',
  QueryInterviewPaper = '/ns-service-app-evaluation/interviewPlan/queryInterviewPlanByTeacher',
  UpdateTestStatus = '/ns-service-app-evaluation/accountActivityLink/updateTestStatusToIng',
  QueryMyReviewer = '/ns-service-app-evaluation/infoReviewerCandidateLink/queryMyReviewer',
  QueryActivityPaperHistory = '/ns-service-app-evaluation/accountActivity/queryActivityPaperHistory',
  QueryReportConfig = '/ns-service-app-report/reportActProPersonnel/queryReportByTester'
}

export function queryActivity(params?: QueryActivityParams) {
  return http.post<any>(
    {
      url: Api.QueryActivity,
      data: params
    },
    {
      isReturnNativeResponse: true
    }
  )
}

export function getActivityPaperHistory() {
  return http.post<any>({
    url: Api.QueryActivity
  })
}

export function getReportConfig(params: { ids: (string | number)[] }) {
  return http.post<Record<string | number, ReportConfigItem>>({
    url: Api.QueryReportConfig,
    data: params
  })
}

export function getReviewActiList() {
  return http.post<ReviewActiItem[]>(
    {
      url: Api.QueryMyReviewer,
      data: {}
    },
    {
      isReturnNativeResponse: true
    }
  )
}

export function getInterviewActiList() {
  return http.post<any>(
    {
      url: Api.QueryInterviewPaper,
      data: {}
    },
    {
      isReturnNativeResponse: true
    }
  )
}

export function getReMarkingActiList() {
  return http.post<any>(
    {
      url: Api.QueryReMarkingPaper,
      data: {}
    },
    {
      isReturnNativeResponse: true
    }
  )
}

export function getLinkNum() {
  return http.post<LinkNums>({
    url: Api.GetLinkNum
  })
}

// 更新测评状态
export function updateTestStatus(params: any) {
  return http.post<any>(
    {
      url: Api.UpdateTestStatus,
      data: params
    },
    {
      isReturnNativeResponse: true
    }
  )
}
